<template>
  <v-container class="pa-0">
    <v-row no-gutters>
      <v-col
        :cols="withSlider ? 12 : 8"
      >
        <div
          :class="'viewer-image ' +
            (homepage ? 'viewer-image-homepage' : '') +
            (compact ? 'viewer-compact-container' : '')"
          v-touch="{
            left: () => nextImg(),
            right: () => prevImg()
          }"
          :style="viewerContainerStyle"
          ref="viewer-image viewer-image-desktop"
          @mouseleave="hideNav"
          @mouseenter="showNav"
        >

          <!--- navigation icons -->

          <div
            v-if="!compact"
            class="viewer-nav"
          >
            <a class="prev-btn" :class="(
              !showingImageNavigation ? ' img-transparent' : ''
              )" @click="prevImg()"
            >
              <i class="fa fa-chevron-left" />
            </a>
            <a class="next-btn" :class="(
              !showingImageNavigation ? ' img-transparent' : ''
              )" @click="nextImg()"
            >
              <i class="fa fa-chevron-right" />
            </a>
            <span :class="'pika-counter ' + (
              !showingImageNavigation ? ' img-transparent' : ''
              )" >{{ selectedImageIndex + 1 }}/{{ images.length }}
            </span>

            <span
              v-if="!homepage"
              :class="'expand-icon ' + (
              !showingImageNavigation ? ' img-transparent' : ''
              )"
              @click="showFull"
            >
              <v-btn
                class="elevation-0"
                dense
                small
              >
                <v-icon small class="mr-1" color="grey darken-2">fa-images</v-icon>
                 <span style="font-size: 18px"></span> {{ $i18n.t('all_images') }}
              </v-btn>

            </span>
          </div>
          <!--- // navigation icons -->

          <!--- preview image area  -->

          <div
            :class="'viewer-image-middle-container '"
          >
            <!-- preload images -->
            <img
              v-if="preloadImg1 && images[preloadImg1]"
              :src="fullPath + images[preloadImg1].image"
              style="width: 30px;position: absolute; left: 10000px"
            />
            <img
              v-if="preloadImg2 && images[preloadImg2]"
              :src="fullPath + images[preloadImg2].image"
              style="width: 30px;position: absolute; left: 10000px"
            />
            <!-- /preload images -->

            <v-img
              :src="fullPath + imageUrl1"
              :class="image1Transparent ? 'img-transparent' : ''"
              :style="previewImageStyle"
              @click="showFull"
            />
            <v-img
              :src="fullPath + imageUrl2"
              :class="image2Transparent ? 'img-transparent' : ''"
              :style="previewImageStyle"
              @click="showFull"
            />
          </div>
          <!--- // preview image area  -->

        </div>

        <!--- homepage title -->

        <div
          v-if="homepage"
          class="hot-img-caption"
          style="display: block; opacity: 1;"
          v-html="imageTitleComputed"
          @click="showFull"
        />

        <!--- slider thumbnails -->
        <div
          v-if="!compact && withSlider"
          class="d-none viewer-thumbnails-outer"
          v-touch="{
            left: () => nextImgPage(),
            right: () => prevImgPage()
          }"
          :style="homepage ? 'width:calc(100% - 276px);left:270px;' : ''"
        >
          <div class="viewer-thumbnails" ref="viewer-thumbnails">
            <template v-if="!compact && compact">
              <div
                v-for="(image, imageIndex) in images"
                :key="imageIndex"
                class="viewer-thumbnail"
                :style="'left:' + imagePreviewThumbnailLeftOffset + 'px'"
              >
                <div
                  class="viewer-thumbnail-inner"
                  @click="changeImage(image, imageIndex)"
                  :ref="'thumbnail-ref-' + imageIndex">
                  <img
                    v-if="image && image.image"
                    :src="s3url + imgFolder + '/' + image.image"
                    :class="'viewer-thumbnail-image' + (
                      imageIndex !== selectedImageIndex ? ' not-selected' : ''
                      )"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
        <!--- // slider thumbnails -->
      </v-col>

      <!-- preview side-images -->
      <v-col
        v-if="!withSlider"
        cols="4"
        class="pl-2"
      >
        <v-row no-gutters>
          <v-col cols="12" class="mb-1" :style="sideImageContainerStyle" style="border-radius: 0 8px 0 0; overflow: hidden;">
            <!-- height 110% is important!
            pictures are 4/3 and 3/2 format, with this setting can cover always 100% of the area -->
            <img
              :src="fullPath + previewSideImage2.image"
              style="height:110%;"
              @click="nextImg(); showFull();"
            />
          </v-col>
          <v-col cols="12" class="mt-1" :style="sideImageContainerStyle" style="border-radius: 0 0 8px 0; overflow: hidden;">
            <img
              :src="fullPath + previewSideImage3.image"
              style="height:110%;"
                @click="nextImg(); nextImg(); showFull();"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import methods from '../../methods/methods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import sharedComputed from '@/methods/sharedComputed'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectImagesPreview',

  data: () => {
    return {

    }
  },

  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    wide: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    imgFolder: {
      type: String,
      default: null
    }
  },

  computed: {
    ...sharedComputed,
    ...mapFields(Object.keys(state)),

    imageTitleComputed () {
      return this.imageTitle.replace(', Costa del Sol, Spain', '')
    },

    contentAreaWidthComputed () {
      return this.contentAreaWidth + (this.wide ? 264 : 0)
    },

    sideImageContainerStyle () {
      console.log('1, ', this.contentAreaWidthComputed)
      return {
        height: (((this.contentAreaWidthComputed / 12 * 4) / 4 * 3) - 4) + 'px',
        // background: 'gray',
        // borderTop: '2px solid white',
        // borderRight: '2px solid white',
        overflow: 'hidden',
        marginTop: '0px'
      }
    },

    withSlider () {
      return !!this.homepage
    },

    fullPath () {
      return this.s3url + this.imgFolder + '/' + (
        this.compact ? 'medium/' : ''
      )
    },

    imageTitle () {
      const img = this['previewImage' + this.whichImageShowing]
      if (!img) {
        return false
      }
      return img && img.objectInfo ? img.objectInfo.objectName + ', ' + img.objectInfo.address + '<br>' + this.$i18n.t('alates') + ' ' +
        (img.objectInfo.dayPrice || (Math.ceil(img.objectInfo.price / 7))) + ('€ / ' + this.$i18n.t('öö').toLowerCase()) : ''
    },

    previewImageStyle () {
      const style = {}
      if (!this.withSlider) {
        // style.height = 'auto'
        // style.width = '100%'
      }
      return style
    },

    viewerContainerStyle () {
      const style = {}
      style.height = ((this.contentAreaWidthComputed - 14) / 16 * 9) + 'px'
      if (!this.withSlider) {
        style.height = ((this.contentAreaWidthComputed - 0) / 16 * 8) + 'px'
      }
      return style
    },

  },

  methods: {
    ...methods,
    ...sharedMethods
  }
}
</script>

<style>

</style>
